import styled from 'styled-components'

export const StyledLonPageHelper = styled.div`
  background: ${({ theme }) => theme.colors.bgBase};
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  .flex-row-around {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around !important;

    > div {
      flex: 1;
    }
  }

  p {
    margin: 0;
  }
  a,
  button {
    cursor: pointer;
  }
  .row {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .flex-column-center {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }

  .lon-card {
    padding: 0;
    border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorder};
    box-sizing: border-box;
    border-radius: 12px;
    margin-top: 20px;
    background: ${({ theme }) => theme.colors.lonCardBgLight};

    .flex-row-between {
      padding: 15px 20px;
      background: ${({ theme }) => theme.colors.lonCardBg};
      &:last-child,
      &:nth-last-child(2) {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      /* &:last-child {
        background: ${({ theme }) => theme.colors.lonCardBgLight};
      } */
    }

    &--light {
      background: #fff;
      border: none;

      .flex-row-between {
        background: #fff;
        border: none;
      }

      .button--light,
      a.button--light,
      a.button.button--light {
        background-color: ${({ theme }) => theme.colors.primaryBgLight};
        color: ${({ theme }) => theme.colors.primary};
      }

      .button--dark {
        background-color: ${({ theme }) => theme.colors.primary};
        color: #fff;
      }
    }

    .divider-wrap {
      background: ${({ theme }) => theme.colors.lonCardBg};

      &--light {
        background: transparent;

        .divider {
          width: calc(100% - 40px);
          margin: 0 auto;
        }
      }

      .divider {
        width: calc(100% - 40px);
        margin: 0 auto;
      }
    }
  }

  .lon-cell {
    width: 375px;
    height: 105px;
    background: ${({ theme }) => theme.colors.lonCardBg};
    border: 0.5px solid ${({ theme }) => theme.colors.lonCardBgLight};
    box-sizing: border-box;
    box-shadow: 0px 4px 20px rgba(57, 53, 92, 0.3);
    border-radius: 12px;
    margin: 10px;
    padding: 25px 24px 28px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    dd {
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      opacity: 0.5;
      margin-bottom: 0;
    }
    dt {
      font-weight: bold;
      font-size: 27px;
      line-height: 27px;
      color: #ffffff;
      margin-top: 10px;
    }
  }

  .flex-row-between,
  .flex-row-around {
    width: 750px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    &.dually {
      .mobile-divider {
        display: none;
      }
    }

    dd {
      font-size: 11px;
      line-height: 13px;
      color: ${({ theme }) => theme.colors.textTertiary};
      margin-bottom: 0;
    }

    dt {
      font-weight: bold;
      font-size: 17px;
      line-height: 21px;
      color: #ffffff;
      margin-top: 9px;
      margin-bottom: 2px;
    }

    button,
    a.button {
      margin: 0;
      border: 0;
      outline: none;
      height: 32px;
      border-radius: 16px;
      font-size: 15px;
      line-height: 32px;
      text-align: center;
      color: #ffffff;
      background: ${({ theme }) => theme.colors.lonCardBtnBg};
      padding: 0 15px;
      cursor: pointer;
      white-space: nowrap;
      display: inline-block;

      &.primary {
        background: ${({ theme }) => theme.colors.primary};
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        padding: 0 45px;
      }
    }
  }

  .exchange-header-wrap {
    background: white;
  }

  .normal-wrap {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    width: 1200px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.colors.lonCardDivider};
    margin: 15px 0;

    &.light {
      background: white;
      opacity: 0.05;
      width: calc(100% - 40px);
    }

    &.gray {
      background-color: ${({ theme }) => theme.colors.lonCardDividerLight};
    }
  }

  .footer-wrap {
    background: white;
    a {
      text-decoration: none;
    }
  }

  .lon-inner-wrap {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0 80px;
    flex: 1;
  }
  .sub-nav {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  dt.reward-value {
    color: ${({ theme }) => theme.colors.textContent};
  }
  @media screen and (max-width: 960px) {
    min-height: 100vh;
    .flex-row-between,
    .flex-row-around {
      width: unset;
    }
    .exchange-header-wrap {
      display: none;
    }

    .footer-wrap {
      display: none;
    }

    .lon-inner-wrap {
      width: 100%;
      padding: 0 15px 30px;

      .flex-row-between.dually,
      .flex-row-between.single {
        flex-flow: row wrap;
        > div {
          width: 50%;
        }
        .mobile-divider {
          display: block;
          height: 1px;
          width: 100%;
          background: ${({ theme }) => theme.colors.lonCardBorder};
          margin: 13px 0;
        }
      }

      .lon-card {
        width: 100%;
        > div {
          width: 100%;
        }
      }
      .mine {
        .lon-cell {
          width: 100% !important;
        }
      }
    }

    dt.reward-value {
      color: ${({ theme }) => theme.colors.textContent};
    }
  }
`

export const StyledLpWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-top: 54px;

  .max-w-755 {
    max-width: 755px;
  }

  .lon-card {
    dt {
      color: ${({ theme }) => theme.colors.textContent};
    }
  }

  .lp-header {
    margin-top: 32px;

    p {
      font-size: 17px;
      line-height: 17px;
      color: ${({ theme }) => theme.colors.textContent};
      margin-top: 15px;
    }
    .pool-logo {
      width: 55px;
      height: 55px;
    }
  }

  .lp-tips-modal {
    color: #ffffff;
    padding-left: 25px;
    padding-right: 25px;

    h1 {
      font-weight: 500;
      font-size: 15px;
      line-height: 27px;
      letter-spacing: 0.01em;
    }
    p {
      color: ${({ theme }) => theme.colors.textTertiary};
      font-size: 15px;
      margin-top: 17px;
    }
  }
  .lp-tips {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.primary};
    margin-top: 10px;
    justify-self: flex-start;
    margin-bottom: 25px;
    width: 100%;

    a {
      font-weight: 500;
      margin-left: 5px;
    }
    @media screen and (max-width: 640px) {
      margin-left: 17px;
    }
  }

  .closed-note {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    margin-top: 30px;

    p {
      font-size: 13px;
      color: ${({ theme }) => theme.colors.textTertiary};
      margin-left: 5px;
    }
  }

  .lp-selectors {
    width: 100%;
    .closed-lp-container {
      padding-top: 12px;
      width: 100%;

      .phase-round {
        font-weight: 500;
        font-size: 13px;
        line-height: 19px;
        color: ${({ theme }) => theme.colors.textTertiary};
      }
      .closed-item-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 0.5px solid ${({ theme }) => theme.colors.lonCardDividerLight};

        .logo-container {
          display: flex;
          align-items: center;
          .token-pair {
            margin-left: 16px;
            color: ${({ theme }) => theme.colors.textContent};
          }
          img {
            width: 31px;
            height: 31px;
          }
          margin-bottom: 13px;
          margin-top: 12px;
          .token-pair {
            font-size: 17px;
            margin-left: 12px;
          }
        }
      }
    }
    > div {
      cursor: pointer;
      background: #fff;
      border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorderLight};
      box-sizing: border-box;
      border-radius: 12px;
      padding: 0 18px 18px;
      margin-bottom: 10px;
      .token-item-container {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        span {
          font-size: 17px;
          line-height: 17px;
          color: #ffffff;
          margin-left: 5px;
        }
        .logo-container {
          display: flex;
          align-items: center;
          .token-pair {
            margin-left: 16px;
            color: ${({ theme }) => theme.colors.textContent};
          }
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 640px) {
    .normal-wrap {
      width: 100%;
      padding: 0 10px 30px;
    }
  }
`

export const StyledClockWrap = styled.div`
  display: flex;
  margin-top: 25px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.textTertiary};

  .clock {
    height: 28px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around;
    border-radius: 14px;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 13px;

    img {
      margin-right: 10px;
    }

    span {
      font-weight: 500;
      padding: 5px 5px;
      line-height: 22px;
      background: ${({ theme }) => theme.colors.primaryBgMedium};
      border-radius: 6.67252px;
      margin: 0 3px;
    }
  }
  .targetDate {
    color: ${({ theme }) => theme.colors.textContent};
  }
  dt {
    font-size: 11px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.textTertiary};
    margin-left: 1em;
  }

  @media screen and (max-width: 640px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 17px;

    .targetDate {
      margin-left: 0;
      margin-top: 10px;
    }
  }
`

export const StyledCloseDivider = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 15px 0 25px 0;
  > div {
    width: 40%;
    height: 1px;
    background-color: rgba(44, 44, 77, 0.1);
    @media screen and (max-width: 640px) {
      width: 20%;
    }
  }
  p {
    font-size: 11px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.textTertiary};
  }
`

export const StyledLPWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  .final-step {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;

    .step {
      color: ${({ theme }) => theme.colors.primary};
      font-size: 11px;
      line-height: 16px;
      margin-bottom: 4px;
      margin-right: 6px;
    }
  }
  .max-w-755 {
    max-width: 755px;
  }

  .lp-header {
    margin-top: 32px;

    p {
      font-size: 17px;
      line-height: 17px;
      color: ${({ theme }) => theme.colors.textContent};
      margin-top: 15px;
    }
    .pool-logo {
      width: 55px;
      height: 55px;
    }
  }

  .lp-tips-modal {
    background: #262c4b !important;
    color: #ffffff;
    padding-left: 25px;
    padding-right: 25px;

    h1 {
      font-weight: 500;
      font-size: 15px;
      line-height: 27px;
      letter-spacing: 0.01em;
    }
    p {
      color: ${({ theme }) => theme.colors.textTertiary};
      font-size: 15px;
      margin-top: 17px;
    }
  }

  .clock-wrap {
    display: flex;
    margin-top: 25px;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    font-variant-numeric: tabular-nums;
    color: ${({ theme }) => theme.colors.textTertiary};

    .clock {
      height: 28px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-around;
      border-radius: 14px;
      color: ${({ theme }) => theme.colors.primary};
      font-size: 13px;

      img {
        margin-right: 10px;
      }

      span {
        font-weight: 500;
        padding: 5px 5px;
        line-height: 22px;
        background: ${({ theme }) => theme.colors.primaryBgMedium};
        border-radius: 6.67252px;
        margin: 0 3px;
      }
    }
    dt {
      font-size: 11px;
      line-height: 22px;
      color: ${({ theme }) => theme.colors.textTertiary};
      margin-left: 1em;
    }
  }

  .lp-tips {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.primary};
    margin-top: 10px;
    justify-self: flex-start;
    margin-bottom: 25px;
    width: 100%;

    a {
      font-weight: 500;
      margin-left: 5px;
    }
  }

  .warning-wrap {
    background: ${({ theme }) => theme.colors.warningBg};
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 10px;
    width: 100%;
    text-align: left;
    p {
      font-weight: normal;
      font-size: 13px;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.warningText};
      word-break: break-all;
    }
  }

  .lp-selectors {
    width: 100%;
    .closed-lp-container {
      width: 100%;
      .closed-item-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 0.5px solid ${({ theme }) => theme.colors.lonCardDividerLight};

        .logo-container {
          display: flex;
          align-items: center;
          .token-pair {
            margin-left: 16px;
            color: ${({ theme }) => theme.colors.textContent};
          }
          img {
            width: 31px;
            height: 31px;
          }
          margin-bottom: 13px;
          margin-top: 12px;
          .token-pair {
            font-size: 17px;
            margin-left: 12px;
          }
        }
      }
    }
    > div {
      cursor: pointer;
      background: #fff;
      border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorderLight};
      box-sizing: border-box;
      border-radius: 12px;
      padding: 0 18px 18px;
      margin-bottom: 10px;
      .token-item-container {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        span {
          font-size: 17px;
          line-height: 17px;
          color: #ffffff;
          margin-left: 5px;
        }
        .logo-container {
          display: flex;
          align-items: center;
          .token-pair {
            margin-left: 16px;
            color: ${({ theme }) => theme.colors.textContent};
          }
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
  .normal-wrap {
    .closed-banner {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      background: ${({ theme }) => theme.colors.lonCardBg};
      border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorderLight};
      box-sizing: border-box;
      border-radius: 12px;
      width: 100%;
      padding: 17px 20px;
      margin-top: 20px;
      cursor: pointer;

      dd {
        font-size: 15px;
        line-height: 22px;
        color: #ffffff;
      }
      dt {
        font-size: 13px;
        color: #fafbfc;
        opacity: 0.5;
      }
    }
    .closed-divider {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin: 15px 0 25px 0;
      > div {
        width: 40%;
        height: 1px;
        background-color: rgba(44, 44, 77, 0.1);
      }
      p {
        font-size: 11px;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.textTertiary};
      }
    }
    .closed-note {
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      margin-top: 30px;

      p {
        font-size: 13px;
        color: ${({ theme }) => theme.colors.primary};
        margin-left: 5px;
      }
    }

    > div {
      width: 100%;

      &.digest-header {
        padding-left: 20px;
        padding-right: 20px;
      }

      &.stake-footer {
        .button {
          color: #fff;
        }
        .rule {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 14px;
            color: white;
          }

          &--dark {
            span {
              color: ${({ theme }) => theme.colors.textContent};
              margin-right: 5px;
            }
          }

          img {
            position: relative;
            top: 1px;
          }
        }
      }
    }

    dt {
      color: ${({ theme }) => theme.colors.textContent} !important;
    }
  }

  .flex-row-between {
    a.button,
    button {
      background: ${({ theme }) => theme.colors.primaryBgLight};
      color: ${({ theme }) => theme.colors.primary};
      span {
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  button {
    position: relative;

    &.primary {
      color: #fff;
      justify-self: flex-end;
    }
    .fixed-button {
      position: absolute;
      background: #41415f;
      border-radius: 8px;
      z-index: 10;
      text-align: left;
      padding: 12px 20px;
      right: 15px;

      dd {
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        color: #9f8cf1;
        margin: 0;
        white-space: nowrap;
      }

      dt {
        font-size: 11px;
        line-height: 21px;
        color: #fafbfc;
        opacity: 0.5;
        margin: 0;
        white-space: nowrap;
      }

      &--light {
        background: #fff;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);

        dd {
          color: ${({ theme }) => theme.colors.primary};
        }
      }
    }
  }

  @media screen and (max-width: 960px) {
    .round-popover {
      border-radius: 8px;
      padding-left: 20px;
      padding-right: 20px;
      .ant-tooltip-inner {
        width: calc(100vw - 20px);
        margin-left: -10px;
        border-radius: 8px;
        overflow-x: scroll;
      }
    }

    .lp-header {
      margin-top: 10px;
    }
    .clock-wrap {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-left: 17px;
      dt {
        margin-left: 0;
        margin-top: 10px;
      }
    }
    .lp-tips {
      margin-left: 17px;
    }
    .lp-selectors {
      width: 100%;
      padding: 0;
      .closed-lp-container {
        width: 100%;
        .closed-item-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 0.5px solid ${({ theme }) => theme.colors.lonCardDividerLight};
          .logo-container {
            margin-bottom: 13px;
            margin-top: 12px;
            .token-pair {
              font-size: 17px;
              margin-left: 12px;
            }
            .logo {
              width: 30px;
              height: 30px;
            }
          }
        }
      }
    }
    .normal-wrap {
      width: 100% !important;
      padding: 0px 10px 30px;
      .dual-reward {
        width: 80%;
      }
      .closed-divider {
        > div {
          width: 20%;
        }
      }
      .closed-note {
        align-items: flex-start;
        img {
          margin-top: 3px;
        }
      }
      .logo-container {
        display: flex;
        align-items: center;
      }
      > div {
        width: 100%;
      }
      .stake-footer {
        flex-flow: column nowrap;
        .rule {
          background: ${({ theme }) => theme.colors.borderSubtle};
          border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorderLight};
          box-sizing: border-box;
          border-radius: 12px;
          padding: 20px;
          width: 100%;
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 75px;

          img {
            top: 0 !important;
          }
        }
        button {
          margin-top: 20px;
          width: 100%;
          border-radius: 8px;
          height: 45px;
          line-height: 45px;
        }
        a.button {
          color: #fff;
        }
        .fixed-button-wrap {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background: #fff;
          padding: 10px;

          a.button.primary {
            width: 100%;
            border-radius: 8px;
            height: 48px;
            line-height: 48px;
          }
        }
      }
    }
    .flex-row-between {
      width: auto;
    }
  }
`

export const StyledModalContent = styled.div`
  padding: 30px;
  .content {
    background: #fff;
    border-radius: 16px;
    width: 435px;
    max-width: 100%;
    margin: 0 auto;
    padding: 45px;
    position: relative;

    .info {
      display: flex;
      justify-content: space-between;
      font-size: 17px;
      line-height: 24px;
      color: #8982be;
      margin-bottom: 15px;
    }

    &.loading {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      color: white;
      padding: 60px 0 40px 0;
      .title {
        font-size: 15px;
        line-height: 24px;
        color: #fafbfc;
        margin: 0;
        margin-top: 15px;
      }
      .subtitle {
        font-size: 13px;
        line-height: 21px;
        color: #ffffff;
        opacity: 0.5;
        margin: 0;
        margin-bottom: 40px;
      }
    }
    .modal-close {
      position: absolute;
      right: 0px;
      top: 0px;
      margin: 10px;
      width: 18px;
      cursor: pointer;
    }
    .balance {
      text-align: right;
      font-size: 11px;
      line-height: 13px;
      color: ${({ theme }) => theme.colors.textSecondary};
      margin-bottom: 10px;
    }

    .input-wrap {
      height: 55px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      padding-right: 10px;
      background: ${({ theme }) => theme.colors.bgInput};

      .redeem-all {
        color: ${({ theme }) => theme.colors.primary};
        background: ${({ theme }) => theme.colors.primaryBgLight};
        border-radius: 8px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
        padding: 8px 10px;
      }

      input {
        background: transparent;
        width: 100%;
        border: none;
        height: 100%;
        outline: none;
        color: ${({ theme }) => theme.colors.textTitle};
        font-size: 17px;
        line-height: 21px;
        padding: 0 8px;
        padding-left: 22px;
      }
    }

    .lp-tips {
      margin-top: 20px;

      p {
        font-weight: 500;
        font-size: 17px;
        line-height: 27px;
        color: ${({ theme }) => theme.colors.textBrand};
      }
    }

    .button-group {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-end;
      margin-top: 10px;
      .arrow {
        margin: 0 5px;
      }
      button {
        outline: none;
        box-sizing: border-box;
        border-radius: 8px;
        color: white;
        width: 164px;
        border-radius: 45px;
        padding: 10px 0;
        cursor: pointer;
        font-size: 16px;

        &.normal {
          background: transparent;
          border: 1px solid ${({ theme }) => theme.colors.primary};
          color: ${({ theme }) => theme.colors.primary};
        }

        &.primary {
          background: ${({ theme }) => theme.colors.primary};
          border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorderLight};
        }

        &.disabled {
          opacity: 0.1;
        }
      }
    }
  }

  @media screen and (max-width: 660px) {
    flex: 1;
    padding: 0;
    .content {
      height: 100%;
      width: 100%;
      padding-top: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      padding-left: 10px;
      padding-right: 10px;

      .input-wrap {
        background: white;
        input {
          color: #666;
        }
      }

      .modal-close {
        margin: 10px;
      }
      .button-group {
        margin-top: 25px;
      }
      button.primary {
        width: 100%;
      }
      .lp-tips {
        padding: 0 15px;
        font-size: 13px;

        p {
          font-size: 13px;
          line-height: 18px;
        }
      }
    }
  }
`

export const StyledFullPageModalContent = styled.div`
  z-index: 1200;
  font-weight: 500;
  font-size: 15px;
  line-height: 27px;
  color: ${({ theme }) => theme.colors.textBrand};
  padding: 30px;
  min-width: 400px;

  p {
    &.plain {
      color: #5a5d6d;
    }
  }

  @media screen and (max-width: 640px) {
    min-width: 100%;
  }
`

export const StyledModalBottomArea = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;

  .btn {
    padding: 12px 30px;
    border: none;
    font-weight: 500;
    font-size: 15px;
    white-space: nowrap;
    outline: none;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 62px;
    color: #ffffff;
    cursor: pointer;
    min-width: 120px;

    &:nth-child(odd) {
      margin-right: 5px;
    }
    &:nth-child(even) {
      margin-left: 5px;
    }

    &.secondary {
      color: ${({ theme }) => theme.colors.primary};
      background: ${({ theme }) => theme.colors.primaryBgMedium};
    }
  }

  @media screen and (max-width: 640px) {
    justify-content: space-around;
    .btn {
      padding: 10px 24px;
      width: 100%;
    }
  }
`
